<h2 matDialogTitle>{{ 'CALL_RECORDINGS_PREFERENCES.HEADER' | translate }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    (click)="close()"
    data-cy="dismiss-dialog-message"
    mat-button
    mat-raised-button
    color="primary"
    type="button">
    {{ 'ONGOING_CALLS.OK' | translate }}
  </button>
</mat-dialog-actions>
